var newWindow;
var download_page = '';
document.querySelectorAll('a[href$="dmg"], a[href$="exe"]').forEach(function(item){
    item.addEventListener('click', function(e){
        newWindow = window.open('about:blank','')
        e.preventDefault();
        window.location.href = item.getAttribute('href');
        newWindow.location.href = window.location.origin + '/download-guidance/'
    })
});